// DON'T EXPORT THIS FILE FROM UI LIBRARY
import React, { Context, Dispatch } from 'react';

import { smallDialogSettingsInitial } from '../constants';
import { NotificationsActions, NotificationsState } from '../notificationsProvider.types';

export const NotificationsDispatchContext: Context<Dispatch<NotificationsActions>> = React.createContext<Dispatch<NotificationsActions>>(
  (): void => undefined
);

export const NotificationsStateContext: Context<NotificationsState> = React.createContext<NotificationsState>({
  toasts: [],
  smallDialogSettings: smallDialogSettingsInitial
});
